import * as THREE from 'three';

export class Lighting {
  constructor(scene) {
    this.scene = scene;
    this.lights = [];
    this.setupLights();
  }

  setupLights() {
    // Ambient light to illuminate the gallery
    // Increased since we're not using per-painting spotlights
    const ambientLight = new THREE.AmbientLight(0xf0f0f0, 3);
    this.scene.add(ambientLight);
    this.lights.push(ambientLight);
  }

  // Add spotlight for a painting
  addPaintingLight(position, target) {
    const spotlight = new THREE.SpotLight(0xffffee, 0.5);
    spotlight.position.copy(position);
    spotlight.target.position.copy(target);
    spotlight.angle = Math.PI / 6; // 30 degrees
    spotlight.penumbra = 0.3;
    spotlight.decay = 2;
    spotlight.distance = 10;
    spotlight.castShadow = true;

    // Shadow settings
    spotlight.shadow.mapSize.width = 512;
    spotlight.shadow.mapSize.height = 512;
    spotlight.shadow.camera.near = 0.5;
    spotlight.shadow.camera.far = 10;

    this.scene.add(spotlight);
    this.scene.add(spotlight.target);
    this.lights.push(spotlight);

    return spotlight;
  }

  // Add point light for ambient glow
  addPointLight(position, color = 0xffffff, intensity = 0.5, distance = 10) {
    const pointLight = new THREE.PointLight(color, intensity, distance);
    pointLight.position.copy(position);
    this.scene.add(pointLight);
    this.lights.push(pointLight);

    return pointLight;
  }

  // Optional: subtle flickering effect for atmosphere
  update(time) {
    // Can add flickering logic here if desired
    // Example: this.lights.forEach(light => {
    //   if (light.isSpotLight) {
    //     light.intensity = 1.5 + Math.sin(time * 2) * 0.1;
    //   }
    // });
  }

  dispose() {
    this.lights.forEach(light => {
      if (light.parent) {
        light.parent.remove(light);
      }
      if (light.dispose) {
        light.dispose();
      }
    });
    this.lights = [];
  }
}
